import {
  businessSection,
  worldSection,
  lifestyleSection,
  featuresSection,
  hongKongCards,
} from "./fixtures";
import { articleArticle23 } from "./article-fixtures";
import type { ArticleCardData } from "@/components/ejinsight/shared/article-card";

export type MostPopularItem = { title: string; category: string; date: string };

// Curated "Most Popular" rail shared by the home page right rail and the
// default EditorialSidebar.
export const defaultMostPopular: MostPopularItem[] = [
  {
    title: businessSection.items[0].title,
    category: "BUSINESS",
    date: businessSection.items[0].date,
  },
  {
    title: worldSection.items[2].title,
    category: "WORLD",
    date: worldSection.items[2].date,
  },
  {
    title: hongKongCards[2].title,
    category: "HONG KONG",
    date: "April 11, 2026",
  },
  {
    title: lifestyleSection.items[0].title,
    category: "LIFESTYLE",
    date: lifestyleSection.items[0].date,
  },
  {
    title: businessSection.items[3].title,
    category: "BUSINESS",
    date: businessSection.items[3].date,
  },
];

// Hong Kong topic block — promote one HK card to feature, two below as list,
// plus a placeholder date since legacy hongKongCards lack dates.
export const hongKongHero: ArticleCardData = {
  title: hongKongCards[0].title,
  author: hongKongCards[0].author,
  date: "April 26, 2026",
  img: hongKongCards[0].img,
  category: "HONG KONG",
  excerpt:
    "A deeper look at how the city's official narrative has evolved — and what's been left out of the public record.",
};
export const hongKongList: ArticleCardData[] = hongKongCards.slice(1, 4).map((c, i) => ({
  title: c.title,
  author: c.author,
  date: ["April 19, 2026", "April 12, 2026", "April 05, 2026"][i],
  img: c.img,
  category: "HONG KONG",
}));

// Business topic block
export const businessHero: ArticleCardData = {
  ...businessSection.items[0],
  category: businessSection.label,
  excerpt:
    "Why the next move from policymakers may matter more than markets are pricing in — and what investors should watch for.",
};
export const businessList: ArticleCardData[] = businessSection.items.slice(1, 4).map((it) => ({
  ...it,
  category: businessSection.label,
}));

// World topic block
export const worldHero: ArticleCardData = {
  ...worldSection.items[0],
  category: worldSection.label,
  excerpt:
    "From the Qing court to the present day — a long view on Sino-foreign relations.",
};
export const worldList: ArticleCardData[] = worldSection.items.slice(1, 4).map((it) => ({
  ...it,
  category: worldSection.label,
}));

// Lifestyle & Features topic block
export const lifestyleHero: ArticleCardData = {
  ...lifestyleSection.items[0],
  category: lifestyleSection.label,
  excerpt:
    "Hong Kong Ballet's bold reinvention asks what classical ballet can borrow from glam rock — and what it should leave behind.",
};
export const lifestyleList: ArticleCardData[] = [
  ...lifestyleSection.items.slice(1, 3),
  featuresSection.items[0],
].map((it, i) => ({
  ...it,
  category: i < 2 ? lifestyleSection.label : featuresSection.label,
}));

// "Today's Read" hero + Editor's Picks rail on the home page.
export const heroTodaysRead = {
  title: articleArticle23.title,
  category: articleArticle23.category.toUpperCase(),
  date: articleArticle23.date,
  author: articleArticle23.authorName,
  img: articleArticle23.heroImage,
  excerpt: articleArticle23.body[0],
  href: `/ejinsight/article/${articleArticle23.slug}`,
};

export const editorsPicks = [
  {
    category: worldSection.label,
    title: worldSection.items[0].title,
    date: worldSection.items[0].date,
    img: worldSection.items[0].img,
  },
  {
    category: businessSection.label,
    title: businessSection.items[0].title,
    date: businessSection.items[0].date,
    img: businessSection.items[0].img,
  },
  {
    category: lifestyleSection.label,
    title: lifestyleSection.items[0].title,
    date: lifestyleSection.items[0].date,
    img: lifestyleSection.items[0].img,
  },
  /* A fourth pick. The rail is a 2-up grid on the tablet band, where three left
     the last card alone on its own row with a gap beside it — QA: "for tablet
     size only: add one more article item to the EDITOR'S PICKS". The renderer
     shows it in that band alone; stacked on a phone and in the `lg` rail the
     list is three. */
  {
    category: featuresSection.label,
    title: featuresSection.items[0].title,
    date: featuresSection.items[0].date,
    img: featuresSection.items[0].img,
  },
];

// Trending ribbon carousel.
export type TrendingItem = {
  category: string;
  title: string;
  date: string;
  img: string;
};

export const trendingItems: TrendingItem[] = [
  {
    category: "WORLD",
    title: worldSection.items[1].title,
    date: worldSection.items[1].date,
    img: worldSection.items[1].img,
  },
  {
    category: "BUSINESS",
    title: businessSection.items[1].title,
    date: businessSection.items[1].date,
    img: businessSection.items[1].img,
  },
  {
    category: "HONG KONG",
    title: hongKongCards[0].title,
    date: "April 22, 2026 09:30",
    img: hongKongCards[0].img,
  },
  {
    category: "LIFESTYLE",
    title: lifestyleSection.items[1].title,
    date: lifestyleSection.items[1].date,
    img: lifestyleSection.items[1].img,
  },
  {
    category: "WORLD",
    title: worldSection.items[2].title,
    date: worldSection.items[2].date,
    img: worldSection.items[2].img,
  },
  {
    category: "BUSINESS",
    title: businessSection.items[2].title,
    date: businessSection.items[2].date,
    img: businessSection.items[2].img,
  },
  {
    category: "HONG KONG",
    title: hongKongCards[1].title,
    date: "April 18, 2026 14:11",
    img: hongKongCards[1].img,
  },
];
